var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStar3 = function SvgStar3(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star-3_svg__a)",
    d: "M5.835.361a.622.622 0 0 1 1.13 0l1.09 2.358a4.15 4.15 0 0 0 2.026 2.026l2.358 1.09a.622.622 0 0 1 0 1.13l-2.358 1.09a4.15 4.15 0 0 0-2.026 2.026l-1.09 2.358a.622.622 0 0 1-1.13 0l-1.09-2.358A4.15 4.15 0 0 0 2.72 8.055L.361 6.965a.622.622 0 0 1 0-1.13l2.358-1.09A4.15 4.15 0 0 0 4.745 2.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star-3_svg__b)",
    d: "M12.518 9.78a.311.311 0 0 1 .564 0l.545 1.18c.207.447.566.806 1.013 1.013l1.18.544c.24.112.24.454 0 .566l-1.18.544a2.08 2.08 0 0 0-1.013 1.013l-.545 1.18a.311.311 0 0 1-.565 0l-.544-1.18a2.08 2.08 0 0 0-1.013-1.013l-1.18-.545a.311.311 0 0 1 0-.565l1.18-.544a2.08 2.08 0 0 0 1.013-1.013z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-3_svg__a",
    x1: -1.306,
    x2: 16.816,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14D9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-3_svg__b",
    x1: -1.306,
    x2: 16.816,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14D9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E44EC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStar3);
export default ForwardRef;